import React from "react";
import { useNavigate } from "react-router-dom";
import "./style.scss";

const TopNavigation = ({
  titlePage,
  toPath,
  setBorder,
  showLeftIcon = true,
  showRightIcon,
  iconRight,
  iconLeft,
  rightEvent = false,
  rightEventPath,
  showRightText,
  rightText,
  iconPointMaps,
  showIconPointMaps = false,
  toPathMap = false,
  onRightNavClicked = () => {},
  onClick = () => {},
  rightTextClassname,
  isCustomLeftNavigation = false,
  onClickLeftCustom,
}) => {
  const navigate = useNavigate();

  const innerStyle = {
    borderBottom: "1px solid #ebebeb",
  };

  const onClickLeftNavigation = () => {
    if (!toPath) {
      onClick();
    } else {
      navigate(toPath);
    }
  };

  const onClickRightNavigation = () => {
    if (rightEvent) {
      navigate(rightEventPath);
    } else {
      onRightNavClicked();
    }
  };

  const onClickMaps = () => {
    navigate(toPathMap);
  };

  return (
    <div
      className="top-navigation"
      style={setBorder ? innerStyle : { boxShadow: "none" }}
    >
      <div
        className="left-navigation"
        onClick={
          isCustomLeftNavigation ? onClickLeftCustom : onClickLeftNavigation
        }
      >
        {showLeftIcon && (
          <img src={iconLeft} className="icon-left" alt="arrow-back" />
        )}
      </div>
      <div className="title-page">{titlePage}</div>
      <div className="map-navigation" onClick={onClickMaps}>
        {showIconPointMaps && (
          <img src={iconPointMaps} className="icon-right" alt="filter" />
        )}
      </div>
      <div className="right-navigation" onClick={onClickRightNavigation}>
        {showRightIcon && (
          <img src={iconRight} className="icon-right" alt="filter" />
        )}
        {showRightText && (
          <span className={rightTextClassname}>{rightText}</span>
        )}
      </div>
    </div>
  );
};

export default TopNavigation;
